"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_modal_1 = __importDefault(require("react-modal"));
const common_styled_components_1 = require("../../../common-styled-components");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../../theme");
const PeriodicalStatementForm_1 = require("./PeriodicalStatementForm");
const BunkerDeliveryNoteForm_1 = require("./BunkerDeliveryNoteForm");
const useMetadata_1 = require("../../../../hooks/useMetadata");
const transactionAttachmentUtil_1 = require("../../admin/util/transactionAttachmentUtil");
const useEdit_1 = __importDefault(require("../../../../hooks/useEdit"));
const apiUtils_1 = require("../../../../util/apiUtils");
const lodash_1 = require("lodash");
const modalStyles = {
    ...common_styled_components_1.baseReactModalStyles,
    content: {
        ...common_styled_components_1.baseReactModalStyles.content,
        minWidth: "480px",
        display: "flex",
    },
};
const ModalContent = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(3)};
  width: 100%;
`;
const Form = styled_components_1.default.form `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(3)};
`;
const FileNameContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${theme_1.theme.spacing(1)};
  padding: ${theme_1.theme.spacing(2)};
  background-color: ${theme_1.theme.colors.grey(5)};
  border-radius: 4px;
`;
const FileNameLabel = styled_components_1.default.span `
  font-size: 0.875rem;
  color: ${theme_1.theme.colors.grey(2)};
  font-weight: 500;
`;
const FileName = styled_components_1.default.span `
  font-family: monospace;
  word-break: break-all;
`;
const TransactionAttachmentEditor = ({ attachmentData, attachmentType, style, periodicalStatementOptions, isOpen: controlledIsOpen, onClose, refresh, }) => {
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const [internalIsOpen, setInternalIsOpen] = (0, react_1.useState)(false);
    const [errorText, setErrorText] = (0, react_1.useState)("");
    const [editableData, setEditableData] = (0, react_1.useState)(attachmentData);
    const [_editStatus, executeEdit] = (0, useEdit_1.default)("admin/transaction_attachment.json", refresh);
    const isOpen = controlledIsOpen !== undefined ? controlledIsOpen : internalIsOpen;
    const handleClose = () => {
        setEditableData(attachmentData);
        setErrorText("");
        if (controlledIsOpen !== undefined) {
            onClose?.();
        }
        else {
            setInternalIsOpen(false);
        }
    };
    const updateValue = (key, value) => {
        setEditableData((prev) => ({ ...prev, [key]: value }));
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (errorText !== "") {
            return;
        }
        const data = (0, lodash_1.pickBy)(editableData, (_value, key) => key !== "ship_imo" &&
            key !== "available_tco2e" &&
            key !== "type" &&
            key !== "port" &&
            key !== "proof_of_sustainability_notes");
        console.log("Submitting edited attachment data:", data);
        executeEdit(data, "PUT");
    };
    const renderForm = () => {
        switch (attachmentType) {
            case 1:
                return ((0, jsx_runtime_1.jsx)(PeriodicalStatementForm_1.PeriodicalStatementForm, { state: editableData, updateValue: updateValue, metadata: metadata }));
            case 2:
                return ((0, jsx_runtime_1.jsx)(BunkerDeliveryNoteForm_1.BunkerDeliveryNoteForm, { state: editableData, updateValue: updateValue, periodicalStatementOptions: periodicalStatementOptions, metadata: metadata }));
            default:
                return null;
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { style: style, children: [(0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: isOpen, onRequestClose: handleClose, contentLabel: `Edit ${transactionAttachmentUtil_1.ATTACHMENT_TYPE_LABELS[attachmentType].singular}`, style: modalStyles, shouldCloseOnEsc: true, children: (0, jsx_runtime_1.jsxs)(ModalContent, { children: [(0, jsx_runtime_1.jsxs)("h2", { children: ["Edit ", transactionAttachmentUtil_1.ATTACHMENT_TYPE_LABELS[attachmentType].singular] }), (0, jsx_runtime_1.jsxs)(FileNameContainer, { children: [(0, jsx_runtime_1.jsx)(FileNameLabel, { children: "Uploaded file:" }), (0, jsx_runtime_1.jsx)(FileName, { children: attachmentData.name })] }), (0, jsx_runtime_1.jsxs)(Form, { onSubmit: handleSubmit, children: [renderForm(), " ", (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { type: "submit", disabled: _editStatus.status !== apiUtils_1.LoaderStatus.Idle, children: _editStatus.status === apiUtils_1.LoaderStatus.Idle
                                        ? "Save Changes"
                                        : "Saving changes..." })] }), errorText && (0, jsx_runtime_1.jsx)("p", { style: { color: theme_1.theme.colors.red }, children: errorText }), _editStatus.status ? (0, jsx_runtime_1.jsx)("p", { children: _editStatus.status }) : null, (0, jsx_runtime_1.jsx)(common_styled_components_1.SecondaryButton, { type: "button", onClick: handleClose, children: "Close" })] }) }), controlledIsOpen === undefined && ((0, jsx_runtime_1.jsxs)(common_styled_components_1.SecondaryButton, { type: "button", onClick: () => setInternalIsOpen(true), children: ["View ", transactionAttachmentUtil_1.ATTACHMENT_TYPE_LABELS[attachmentType].singular] }))] }));
};
exports.default = TransactionAttachmentEditor;
